'use client';

import { ArrowUpRight } from 'lucide-react';

interface FollowUpSuggestionsProps {
	suggestions: string[];
	onSuggestionClick: (suggestion: string) => void;
}

export function FollowUpSuggestions({ suggestions, onSuggestionClick }: FollowUpSuggestionsProps) {
	if (suggestions.length === 0) return null;

	return (
		<div className='border-border mt-4 flex flex-wrap gap-2 border-t pt-3'>
			{suggestions.map((suggestion) => (
				<button
					key={suggestion}
					type='button'
					onClick={() => onSuggestionClick(suggestion)}
					className='border-border text-muted-foreground hover:bg-accent hover:text-foreground inline-flex items-center gap-1 rounded-full border px-3 py-1.5 text-xs transition-colors'
				>
					{suggestion}
					<ArrowUpRight className='size-3 shrink-0' />
				</button>
			))}
		</div>
	);
}
